const DEFAULT_BACKEND_PORT = process.env.REACT_APP_BACKEND_PORT || '9000';
const DEFAULT_API_URL = `http://localhost:${DEFAULT_BACKEND_PORT}`;

export const API_BASE_URL = process.env.REACT_APP_API_URL || DEFAULT_API_URL;
